import { translateText } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import BestFacilities from '../../components/shared/BestFacilities';
import { useSelector, useDispatch } from 'react-redux';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { showErrorMsg, showSuccessMsg, validateAnyFormField } from '../../../helpers/ValidationHelper';
import { MakeApiCallSynchronous, MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import rootAction from '../../../stateManagment/actions/rootAction';
import { makePriceRoundToTwoPlaces, makeProductShortDescription } from '../../../helpers/ConversionHelper';
import { Helmet } from 'react-helmet';
import { GetDefaultCurrencySymbol, getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';
import GlobalEnums from '../../../helpers/GlobalEnums';
import { meetsMinimumOrderTotal, MINIMUM_ORDER_MESSAGE, MINIMUM_ORDER_GUIDANCE } from '../../../helpers/OrderValidationHelper';


const formatCartWeight = (value) => {
    const displayValue = String(value ?? '').trim();
    const fractionalWeight = displayValue.match(/^0?(\.\d+)\s*g$/i);

    if (!fractionalWeight) return displayValue;

    const grams = Number(fractionalWeight[1]) * 1000;
    return Number.isFinite(grams) ? `${Math.round(grams)}g` : displayValue;
};


const Cart = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [adminPanelBaseURL, setadminPanelBaseURL] = useState(Config['ADMIN_BASE_URL']);
    const [CartChanged, setCartChangedStatusCount] = useState(0);
    const [CartSubTotal, setCartSubTotal] = useState(0);
    const [ShippingSubTotal, setShippingSubTotal] = useState(0);
    const [OrderTotal, setOrderTotal] = useState(0);
    const [cartProductsData, setCartProductsData] = useState(0);
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
    const [selectedVariantsByProduct, setSelectedVariantsByProduct] = useState({});
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const loginUserDataJson = useSelector(state => state.userReducer.user);
    const loginUser = JSON.parse(loginUserDataJson ?? "{}");
    const [quantityError, setQuantityError] = useState(false);
    const cartJsonDataSession = useSelector(state => state.cartReducer.cartItems);
    const cartItemsSession = JSON.parse(cartJsonDataSession ?? "[]");

    // if (loginUser == undefined || loginUser.UserID == undefined || loginUser.UserID < 1) {
    //     navigate('/login');
    // }

    const handleSubtractQuantity = (ProductId) => {
        let qty = cartProductsData?.find(x => x.ProductId == ProductId).Quantity;
        if (qty > 1) {

            let IndexPrd = cartItemsSession.findIndex((obj => obj.ProductId == ProductId));
            cartItemsSession[IndexPrd].Quantity = ((qty) - 1);

            //--store in storage
            localStorage.setItem("cartItems", JSON.stringify(cartItemsSession));
            //store in redux
            dispatch(rootAction.cartAction.setCustomerCart(JSON.stringify(cartItemsSession)));

            //--update in "cartProductsData"
            let IndexPrdCartProduct = cartProductsData.findIndex((obj => obj.ProductId == ProductId));
            cartProductsData[IndexPrdCartProduct].Quantity = ((qty) - 1);


            //-- set total, sub total, shipping
            setCartTotalSubTotalShippingTotalAfterUpdate();

            //--change the value so that new data uploaded in useEffect
            //setCartChangedStatusCount(CartChanged + 1);
        }
    }

    const handleAddQuantity = (ProductId, OrderMaximumQuantity) => {


        let qty = cartProductsData?.find(x => x.ProductId == ProductId).Quantity;

        if (OrderMaximumQuantity != undefined && OrderMaximumQuantity != null && OrderMaximumQuantity > 0) {
            if ((qty + 1) > OrderMaximumQuantity) {
                showErrorMsg(`Can not add more than ${OrderMaximumQuantity} for this product`);
                return false;
            }
        }



        if (qty < 10) {



            let IndexPrd = cartItemsSession.findIndex((obj => obj.ProductId == ProductId));
            cartItemsSession[IndexPrd].Quantity = ((qty) + 1);

            //--store in storage
            localStorage.setItem("cartItems", JSON.stringify(cartItemsSession));
            //store in redux
            dispatch(rootAction.cartAction.setCustomerCart(JSON.stringify(cartItemsSession)));

            //--update in "cartProductsData"
            let IndexPrdCartProduct = cartProductsData.findIndex((obj => obj.ProductId == ProductId));
            cartProductsData[IndexPrdCartProduct].Quantity = ((qty) + 1);

            //-- set total, sub total, shipping
            setCartTotalSubTotalShippingTotalAfterUpdate();

            //--change the value so that new data uploaded in useEffect
            // setCartChangedStatusCount(CartChanged + 1);
        }
    }

    const handleQtyUpdate = (ProductId, OrderMaximumQuantity, newValue) => {
        
        setQuantityError(false);
        newValue = (newValue == null || newValue == undefined || newValue == 0) ? 1 : newValue;
        let qty = cartProductsData?.find(x => x.ProductId == ProductId).Quantity;

        if (OrderMaximumQuantity != undefined && OrderMaximumQuantity != null && OrderMaximumQuantity > 0) {
            if ((newValue) > OrderMaximumQuantity) {
                showErrorMsg(`Can not add more than ${OrderMaximumQuantity} for this product`);
                setQuantityError(true);
                return false;
            }
        }

        if (qty < 10) {



            let IndexPrd = cartItemsSession.findIndex((obj => obj.ProductId == ProductId));
            cartItemsSession[IndexPrd].Quantity = newValue;

            //--store in storage
            localStorage.setItem("cartItems", JSON.stringify(cartItemsSession));
            //store in redux
            dispatch(rootAction.cartAction.setCustomerCart(JSON.stringify(cartItemsSession)));

            //--update in "cartProductsData"
            let IndexPrdCartProduct = cartProductsData.findIndex((obj => obj.ProductId == ProductId));
            cartProductsData[IndexPrdCartProduct].Quantity = newValue;

            //-- set total, sub total, shipping
            setCartTotalSubTotalShippingTotalAfterUpdate();

            //--change the value so that new data uploaded in useEffect
            // setCartChangedStatusCount(CartChanged + 1);
        }
    }


    const handleRemove = (ProductId) => {

        //--remove from session
        let updatedProductsList = cartItemsSession.filter(item => item.ProductId != ProductId);

        //--store in storage
        localStorage.setItem("cartItems", JSON.stringify(updatedProductsList));
        //store in redux
        dispatch(rootAction.cartAction.setCustomerCart(JSON.stringify(updatedProductsList)));
        dispatch(rootAction.cartAction.SetTotalCartItems(updatedProductsList != undefined && updatedProductsList != null ? updatedProductsList.length : (0)));

        //--remove from "cartProductsData"
        let IndexPrdCartData = cartProductsData.findIndex((obj => obj.ProductId == ProductId));
        if (IndexPrdCartData > -1) {
            cartProductsData.splice(IndexPrdCartData, 1);
        }

        //-- set total, sub total, shipping
        setCartTotalSubTotalShippingTotalAfterUpdate();

        //--change the value so that new data uploaded in useEffect
        setCartChangedStatusCount(CartChanged + 1);
    }

    const setCartTotalSubTotalShippingTotalAfterUpdate = () => {

        if (cartProductsData != undefined && cartProductsData != null && cartItemsSession.length > 0) {

            let CartSubTotalDummy = 0;
            let ShippingSubTotalDummuy = 0;
            let OrderTotalDummu = 0;
            for (let i = 0; i < cartProductsData.length; i++) {

                let itemSubTotal = (cartProductsData[i].DiscountedPrice != undefined && cartProductsData[i].DiscountedPrice != null && cartProductsData[i].DiscountedPrice > 0 ? cartProductsData[i].DiscountedPrice : cartProductsData[i].Price) * (cartProductsData[i].Quantity ?? 1);
                cartProductsData[i].ItemSubTotal = itemSubTotal;
                CartSubTotalDummy = CartSubTotalDummy + itemSubTotal;
                ShippingSubTotalDummuy = ShippingSubTotalDummuy + (cartProductsData[i].ShippingCharges ?? 0);
                OrderTotalDummu = OrderTotalDummu + (itemSubTotal + (cartProductsData[i].ShippingCharges ?? 0));

            }

            setTimeout(() => {

                setCartSubTotal(makePriceRoundToTwoPlaces(CartSubTotalDummy));
                setShippingSubTotal(makePriceRoundToTwoPlaces(ShippingSubTotalDummuy));
                setOrderTotal(makePriceRoundToTwoPlaces(OrderTotalDummu));

            }, 500);
        }
    }

    const loadSelectedAttributesForCart = async (products) => {
        const headersProdAttribte = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }

        const variantEntries = await Promise.all((products ?? []).map(async (product) => {
            const selectedAttributes = cartItemsSession.find(x => x.ProductId == product.ProductId)?.productSelectedAttributes ?? [];
            if (selectedAttributes.length === 0) return [product.ProductId, []];

            const paramProdAttribute = {
                requestParameters: {
                    ProductId: product.ProductId,
                    recordValueJson: "[]",
                },
            };
            const response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_PRODUCT_ALL_ATTRIBUTES_BY_ID'], null, paramProdAttribute, headersProdAttribte, "POST", true);
            const allAttributes = response?.data?.data ? JSON.parse(response.data.data) : [];
            const selectedDetails = selectedAttributes.map(selected => {
                const attribute = allAttributes.find(attribute =>
                    attribute.ProductAttributeID == selected.ProductAttributeID &&
                    attribute.PrimaryKeyValue == selected.PrimaryKeyValue
                );

                if (!attribute) return null;

                if (selected.ProductAttributeID == Config.PRODUCT_ATTRIBUTE_ENUM['Size']) {
                    const selectedSize = product.ProductSizesJson?.find(size =>
                        size.SizeID == selected.PrimaryKeyValue
                    );

                    return {
                        ...attribute,
                        PrimaryKeyDisplayValue: selectedSize?.ShortName || formatCartWeight(attribute.PrimaryKeyDisplayValue)
                    };
                }

                return attribute;
            }).filter(Boolean);

            return [product.ProductId, selectedDetails];
        }));

        setSelectedVariantsByProduct(Object.fromEntries(variantEntries));
    }



    useEffect(() => {

        window.scrollTo(0, 0)
        // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            const headers = {
                Accept: 'application/json',
'Content-Type': 'application/json'
            }

            // let ProductsIds = [];
            // if (cartItemsSession != undefined && cartItemsSession != null && cartItemsSession.length > 0) {
            //     for (let i = 0; i < cartItemsSession.length; i++) {
            //         ProductsIds.push({
            //             ProductId: cartItemsSession[i].ProductId ?? 0
            //         });
            //     }
            // }


            //--Get cart data
            const paramCart = {
                requestParameters: {
                    cartJsonData: JSON.stringify(cartItemsSession),
                    recordValueJson: "[]",
                },
            };


            const customerCartResponse = await MakeApiCallAsync(Config.END_POINT_NAMES["GET_CUSTOMER_CART_ITEMS"], Config['COMMON_CONTROLLER_SUB_URL'], paramCart, headers, "POST", true);
            if (customerCartResponse != null && customerCartResponse.data != null) {

                let finalData = JSON.parse(customerCartResponse.data.data);
                console.log(finalData);

                if (finalData != null) {
                    await loadSelectedAttributesForCart(finalData.productsData);
                    setTimeout(() => {

                        setCartProductsData(finalData.productsData);
                        setCartSubTotal(finalData.cartSubTotal);
                        setShippingSubTotal(finalData.shippingSubTotal);
                        setOrderTotal(finalData.orderTotal);

                    }, 500);

                }


            }

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["Cart"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }

        }


        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));


        // call the function
        dataOperationInUseEffect().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);

    }, [CartChanged])






    return (
        <>
          <Helmet>
                <title>{siteTitle}{translateText(" - cart")}</title>
                <meta name="description" content={siteTitle + " cart"} />
                <meta name="keywords" content="cart, Uthukuli butter online, Buy Uthukuli butter, Traditional butter Tamil Nadu, Desi butter online India,UKL Butter, dairy products, fresh butter"></meta>
            </Helmet>
            <SiteBreadcrumb title={translateText("cart")} parent="Home" />
            <section className="cart-section section-big-py-space bg-light">
                <div className="custom-container">
                    {cartProductsData != undefined && cartProductsData != null && cartProductsData.length > 0 > 0 ? (
                        <>
                            <div className="ukl-cart-heading">
                                <div>
                                    <span>{translateText("Your basket")}</span>
                                    <h1>{translateText("Shopping Cart")}</h1>
                                    <p>{cartProductsData.length} {translateText(cartProductsData.length === 1 ? "item" : "items")}{translateText(" ready for checkout")}</p>
                                </div>
                            </div>

                            <div className="ukl-cart-layout">
                                <div className="ukl-cart-items" aria-label={translateText("Cart items")}>
                                    {cartProductsData.map((item, index) => {
                                        const itemPrice = item.DiscountedPrice != undefined && item.DiscountedPrice > 0 ? item.DiscountedPrice : item.Price;
                                        const itemSubTotal = itemPrice * (item.Quantity ?? 1);
                                        const productUrl = `/${getLanguageCodeFromSession()}/product-detail/${item.ProductId}/category/${item.ProductName}`;

                                        return (
                                            <article className="ukl-cart-item" key={`cart-list-${index}`}>
                                                <Link to={productUrl} className="ukl-cart-item__image">
                                                    <img
                                                        src={item.ProductImagesJson?.[0]?.AttachmentURL ? adminPanelBaseURL + item.ProductImagesJson[0].AttachmentURL : ""}
                                                        alt={translateText(item.ProductName)}
                                                    />
                                                </Link>

                                                <div className="ukl-cart-item__details">
                                                    <Link to={productUrl} className="ukl-cart-item__name">
                                                        {translateText(makeProductShortDescription(item.ProductName, 80))}
                                                    </Link>
                                                    {selectedVariantsByProduct[item.ProductId]?.length > 0 && (
                                                        <div className="ukl-cart-variants" aria-label={translateText("Selected product options")}>
                                                            {selectedVariantsByProduct[item.ProductId].map((variant, variantIndex) => {
                                                                const variantImage = variant.ImageUrl || variant.ImageURL || variant.AttachmentURL;
                                                                const variantColor = variant.HexCode || variant.ColorHexCode;

                                                                return (
                                                                    <span className="ukl-cart-variant" key={`${item.ProductId}-variant-${variantIndex}`}>
                                                                        {variantImage ? (
                                                                            <img src={adminPanelBaseURL + variantImage} alt="" />
                                                                        ) : variantColor ? (
                                                                            <i className="ukl-cart-variant__color" style={{ backgroundColor: variantColor }} aria-hidden="true" />
                                                                        ) : (
                                                                            <i className="fa fa-tag" aria-hidden="true" />
                                                                        )}
                                                                        <small>{translateText(variant.AttributeDisplayName)}</small>
                                                                        <strong>{translateText(variant.PrimaryKeyDisplayValue)}</strong>
                                                                    </span>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                    <div className="ukl-cart-item__unit-price">
                                                        {item.DiscountedPrice != undefined && item.DiscountedPrice > 0 && (
                                                            <del>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(item.Price)}</del>
                                                        )}
                                                        <span>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(itemPrice)}</span>
                                                    </div>
                                                </div>

                                                <div className="ukl-cart-item__quantity">
                                                    <span className="ukl-cart-item__label">{translateText("Quantity")}</span>
                                                    <div className={`ukl-cart-qty ${quantityError ? "ukl-cart-qty--error" : ""}`}>
                                                        <button type="button" onClick={() => handleSubtractQuantity(item.ProductId)} aria-label={translateText(`Decrease quantity of ${item.ProductName}`)}>
                                                            <i className="fa fa-minus" aria-hidden="true" />
                                                        </button>
                                                        <input
                                                            type="number"
                                                            name="quantity"
                                                            min="1"
                                                            max={item.OrderMaximumQuantity || 10}
                                                            onChange={(e) => handleQtyUpdate(item.ProductId, item.OrderMaximumQuantity, e.target.value)}
                                                            value={item.Quantity}
                                                            aria-label={translateText(`Quantity of ${item.ProductName}`)}
                                                        />
                                                        <button type="button" onClick={() => handleAddQuantity(item.ProductId, item.OrderMaximumQuantity)} aria-label={translateText(`Increase quantity of ${item.ProductName}`)}>
                                                            <i className="fa fa-plus" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="ukl-cart-item__total">
                                                    <span className="ukl-cart-item__label">{translateText("Item total")}</span>
                                                    <strong>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(itemSubTotal)}</strong>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="ukl-cart-remove"
                                                    onClick={() => handleRemove(item.ProductId)}
                                                    aria-label={translateText(`Remove ${item.ProductName} from cart`)}
                                                >
                                                    <i className="fa fa-trash-o" aria-hidden="true" />
                                                    <span>{translateText("Remove")}</span>
                                                </button>
                                            </article>
                                        );
                                    })}
                                    <div className="ukl-cart-actions">
                                        <Link to={`/${getLanguageCodeFromSession()}/`} className="ukl-cart-continue">
                                            <i className="fa fa-arrow-left" aria-hidden="true" />
                                            {translateText(LocalizationLabelsArray.length > 0 ? replaceLoclizationLabel(LocalizationLabelsArray, "Continue Shopping", "lbl_cart_cont_shop") : "Continue Shopping")}
                                        </Link>
                                        <Link to={`/${getLanguageCodeFromSession()}/checkout`} className="ukl-cart-checkout">
                                            {translateText(LocalizationLabelsArray.length > 0 ? replaceLoclizationLabel(LocalizationLabelsArray, "Proceed to Checkout", "lbl_cart_proc_check") : "Proceed to Checkout")}
                                            <i className="fa fa-arrow-right" aria-hidden="true" />
                                        </Link>
                                    </div>
                                </div>

                                <aside className="ukl-cart-summary" aria-label={translateText("Order summary")}>
                                    <div className="ukl-cart-summary__title">
                                        <div>
                                            <span>{translateText("Your order")}</span>
                                            <h2>{translateText("Order Summary")}</h2>
                                        </div>
                                        <i className="fa fa-shopping-basket" aria-hidden="true" />
                                    </div>
                                    <div className="ukl-cart-summary__row">
                                        <span>{translateText("Cart Subtotal")}</span>
                                        <strong>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(CartSubTotal)}</strong>
                                    </div>
                                    <div className="ukl-cart-summary__row">
                                        <span>{translateText("Packing & Shipping")}</span>
                                        <strong>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(ShippingSubTotal)}</strong>
                                    </div>
                                    <div className="ukl-cart-summary__row ukl-cart-summary__total">
                                        <span>{translateText("Total")}</span>
                                        <strong>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(OrderTotal)}</strong>
                                    </div>
                                    {!meetsMinimumOrderTotal(OrderTotal) && (
                                        <div className="alert alert-warning" role="alert">
                                            <strong>{translateText(MINIMUM_ORDER_MESSAGE)}</strong>
                                            <div>{translateText(MINIMUM_ORDER_GUIDANCE)}</div>
                                        </div>
                                    )}
                                </aside>
                            </div>
                        </>
                    ) : (
                        <div className="ukl-cart-empty">
                            <img src={`static/images/icon-empty-cart.png`} alt={translateText("Empty shopping cart")} />
                            <span>{translateText("Your basket")}</span>
                            <h1>{translateText("Your cart is empty")}</h1>
                            <p>{translateText("Discover our products and add something you love.")}</p>
                            <Link to={`/${getLanguageCodeFromSession()}/`} className="ukl-cart-checkout">{translateText("Start shopping ")}<i className="fa fa-arrow-right" /></Link>
                        </div>
                    )}
                </div>
            </section>



            {/* The selected variants are displayed inline with each cart item.
                <ModalBody className="modal-content">
                    <Button className="close" data-dismiss="modal" aria-label="Close"
                        onClick={(e) => {
                            e.preventDefault();
                            closeProductVariantPopup();
                        }}
                    >
                        <span aria-hidden="true">×</span>
                    </Button>
                    <div className="news-latter">
                        <div className="modal-bg">
                            <div className="offer-content">
                                <div>
                                    <h2 style={{marginBottom: "23px"}}>Variants Detail!</h2>


                                    <ul className="list-group">


                                        {
                                            productSelectedAttributes?.map((item, idx) =>

                                                <li className="list-group-item">
                                                    <h3 className="product-variant-title">{item.AttributeDisplayName}</h3>
                                                    <div className="form-check form-check-inline"><label className="form-check-label" for="3Processor1">{item.PrimaryKeyDisplayValue}</label></div>

                                                </li>


                                            )}





                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            */}



        </>
    );
};

export default Cart;
